import { Bell, BellOff, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { usePush } from "@/hooks/use-push";

export const PushToggle = ({ className }: { className?: string }) => {
  const { state, enable, disable } = usePush();
  if (state === "loading" || state === "unsupported") return null;
  if (state === "ios-install") return <p className={`text-xs text-muted-foreground ${className ?? ""}`}>Para receber notificações no iPhone, adicione a app ao ecrã principal (Partilhar → Adicionar ao ecrã principal).</p>;
  if (state === "denied") return <p className={`text-xs text-muted-foreground ${className ?? ""}`}>Notificações bloqueadas nas definições do navegador.</p>;
  const on = state === "on";
  return (
    <Button variant="outline" className={`gap-2 ${className ?? ""}`} onClick={async () => {
      if (on) { await disable(); toast("Notificações desativadas"); }
      else { const ok = await enable(); toast(ok ? "Notificações ativadas 🔔" : "Não foi possível ativar as notificações"); }
    }}>
      {on ? <BellOff size={16} /> : <Bell size={16} />}{on ? "Desativar notificações" : "Ativar notificações"}
    </Button>
  );
};
